import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import saveAs from 'file-saver';
import { Table } from 'primeng/table';
import {
  ProgramTypesGUID,
  PaymentBatchStatus,
  Milestone2PaymentBatchStatus,
  SpecialInvestmentPaymentScheduleTab,
  ProgramTypes
} from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { CsiMilestone2PaymentBatchDetails } from '../../../models/csi-milestone2-payment-batch-details.model';
import { CsiPaymentScheduleActivitiesM2 } from '../../../models/csi-payment-schedule-activities-m2.model';
import { DownloadPaymentScheduleCSV } from '../../../models/download-payment-schedule-csv.model';
import { Milestone2PaymentScheduleBatch } from '../../../models/milestone2-payment-schedule-batch.model';
import { M2PaymentBatchEngagementExport } from '../../../models/payment-batch-engagement.model';
import { PaymentBatchStatusM2 } from '../../../models/payment-batch-status-m2.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { CSIPaymentScheduleService } from '../../services/csi-payment-schedule.service';
import { ExportService } from '../../services/export.service';
import { WorkshopCodeService } from '../../services/workshop-code.service';

@Component({
  selector: 'app-csi-edit-milestone2-payment-batch',
  templateUrl: './csi-edit-milestone2-payment-batch.component.html',
  styleUrls: ['./csi-edit-milestone2-payment-batch.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class CsiEditMilestone2PaymentBatchComponent implements OnInit {
  program: ProgramTypesGUID = ProgramTypesGUID.MSSP;

  @ViewChild('dt', { static: false }) dt!: Table;
  pbName!: string;
  editPaymentBatchForm!: FormGroup;
  selectedpaymentBatchStatusID: any;
  isBatchInOpenStatus = false;
  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  paymentBatchEngagement: CsiPaymentScheduleActivitiesM2[] = [];
  engagementList: CsiPaymentScheduleActivitiesM2[] = [];
  paymentBatchEngagementExport: M2PaymentBatchEngagementExport[] = [];
  paymentBatchStatus: PaymentBatchStatusM2[] = [];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  marked = false;
  updatePaymentBatch!: CsiMilestone2PaymentBatchDetails;
  selectedEngagements!: CsiPaymentScheduleActivitiesM2[];
  clonedEngs: Record<number, CsiPaymentScheduleActivitiesM2> = {};
  editing = false;
  editingHeaderCheck = false;
  editingNav = false;
  check = false;
  showForm = true;
  disableSubmit = false;
  isSpin = false;
  isSpinEx = false;
  downloadCSV: DownloadPaymentScheduleCSV[] = [];
  copyAssociatedEngagements!: CsiPaymentScheduleActivitiesM2[];
  editedRowEngagementIds: number[] = [];
  addedRowEngagementIds: number[] = [];
  deletedRowEngagementIds: number[] = [];
  firstEditInitEng!: CsiPaymentScheduleActivitiesM2;
  editRowsCtr = 0;
  isShowOnlyAssoctd = true;
  isDataLoading = false;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  programtypes = [
    { programName: 'MCAP', programTypeID: 1 },
    { programName: 'MSSP', programTypeID: 2 },
    { programName: 'Operator', programTypeID: 3 },
    { programName: 'Advisor Incentive', programTypeID: 5 }
  ];
  isAmountreduced = false;
  datePipe = new DatePipe('en-US');

  constructor(
    private csiPaymentService: CSIPaymentScheduleService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    public settings: SettingsService,
    private exportService: ExportService,
    public http: HttpClient,
    public workshopcodeService: WorkshopCodeService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.pbName = this.route.snapshot.paramMap.get('pbName') || '';
    this.editing = false;
    this.editingHeaderCheck = false;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.engcols = [
      { field: 'engagementId', header: 'Activity ID' },
      { field: 'paymentLineItemId', header: 'Line Item Id' },
      { field: 'engagementName', header: 'Activity Name' },
      { field: 'engagementSubType', header: 'Sub Type' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'payeeID', header: 'Payee ID' },
      { field: 'tier', header: 'Tier' },
      { field: 'fundingAmount', header: 'Funding Amount' },
      { field: 'paymentProfileStatus', header: 'Profile Status' },

      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'sspaStatus', header: 'SSPA Status' },

      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'partnerId', header: 'Partner ID' },
      { field: 'vendorID', header: 'Vendor ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'amount', header: 'Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionID',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.getPaymentBatchStatus();

    this.editPaymentBatchForm = this.formBuilder.group({
      paymentBatchName: [''],
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEngs: [''],
      tier: [''],
      fundingAmount: [''],
      amount: [''],
      partnerId: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      netAmount: [''],
      actualizedAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionID: [''],
      paymentCentralRequestID: ['']
    });

    this.getPaymentBatchActivity(this.pbName);
    this.getDownloadCSVFile(this.pbName);
  }

  getDownloadCSVFile(bname) {
    this.csiPaymentService
      .getDownloadCSVFileEdit(bname)
      .subscribe(downloadReport => {
        this.downloadCSV = downloadReport;
      });
  }

  downloadExportCSV() {
    this.isSpinEx = true;
    const headers = new HttpHeaders();
    const downloadUrl =
      this.settings.baseUrl + 'api/PoeInformation/DownloadPOEDocs';
    const selectedID = this.selectedEngagements;
    this.http
      .post(downloadUrl, selectedID, {
        headers,
        responseType: 'blob'
      })
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        this.downloadExportPoeCSV();
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value + '.zip'
        );
      });
  }
  downloadExportPoeCSV() {
    this.isSpinEx = true;
    const selectedID = this.selectedEngagements;
    this.csiPaymentService
      .downloadExportPoeCSV(selectedID)
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value +
          '-Survey' +
          '.zip'
        );
      });
  }
  exportCSV() {
    this.paymentBatchEngagementExport = [];
    this.engagementList.forEach(data => {
      this.paymentBatchEngagementExport.push({
        PartnerID: data.partnerId,
        VendorID: data.vendorID,
        PartnerName: data.partnerName,
        BlockedStatus: data.blockedStatus,
        EngagementID: data.engagementId,
        WorkshopName: data.engagementSubType,
        POECompletionDate: this.datePipe.transform(data.poecompletionDate, 'MM/dd/yyyy') || '',
        EarnedMonth: data.m2CategoryTypeValue,
        TotalPaymentAmount: data.fundingAmount,
        ActualizedAmount: data.actualizedAmount,
        MSInvoicePaidDate: this.datePipe.transform(data.msInvoicePaidDate, 'MM/dd/yyyy') || '',
        PaymentCentralTransactionID: data.paymentCentralTransactionID,
        MSInvoiceNumber: data.msInvoiceNumber,
      });
    });

    this.exportService.exportExcel(
      this.paymentBatchEngagementExport,
      this.pbName
    );
  }

  setMessage(msg: any, severity: string, noReset?: boolean) {
    if (!noReset) {
      this.msgs = [];
    }
    this.msgs.push({ severity: severity || 'error', detail: msg });
  }

  isEngagementInAssociated(engagementId: number) {
    return this.copyAssociatedEngagements.some(
      e => Number(e.engagementId) === engagementId
    );
  }

  async getPaymentBatchActivity(pbName: string): Promise<void> {
    this.csiPaymentService
      .getMilestone2PaymentBatchActivities(pbName)
      .subscribe(paymentBatchDetails => {
        this.pbName = pbName;
        this.isBatchInOpenStatus =
          paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatusId ==
          PaymentBatchStatus.Open;
        this.editPaymentBatchForm.controls['paymentBatchStatus'].setValue({
          id: paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatusId,
          status: paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatus
        });

        const datePipe = new DatePipe('en-US');
        const epaymentBatchScheduleDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.paymentBatchScheduleDate,
          'MM/dd/yyyy'
        );
        const eanticipatedPaymentDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.anticipatedPaymentDate,
          'MM/dd/yyyy'
        );
        const eactualPaymentCentralDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.actualPaymentCentralDate,
          'MM/dd/yyyy'
        );

        this.editPaymentBatchForm.patchValue({
          paymentBatchName:
            paymentBatchDetails.paymentScheduleBatch?.paymentBatchName,
          paymentBatchScheduleDate: epaymentBatchScheduleDate,
          anticipatedPaymentDate: eanticipatedPaymentDate,
          actualPaymentCentralDate: eactualPaymentCentralDate,
          paymentCentralRequestID:
            paymentBatchDetails.paymentScheduleBatch?.paymentCentralRequestID
        });

        this.paymentBatchEngagement = paymentBatchDetails.activities || [];

        this.onAddNewActivity(true);
        this.selectedEngagements = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.copyAssociatedEngagements = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.engagementList = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.engagementList.forEach(item => {
          if (
            Number(item.fundingAmount) !== item.actualizedAmount &&
            item.programTypeId === this.ProgramType.MSSP
          ) {
            this.isAmountreduced = true;
          }
        });
        this.paymentBatchEngagement.forEach(item => {
          if (item.associated === 1) {
            item.editCheckBox = true;
          }
        });
        this.loading = false;
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.isShowOnlyAssoctd) {
      if (
        this.paymentBatchEngagement === null ||
        this.paymentBatchEngagement.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        if (this.dt) {
          this.dt.sortField = 'engagementId';
          this.dt.sortOrder = -1;
          this.dt.reset();
        }
        this.totalRecords = this.paymentBatchEngagement.length;

        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    } else {
      if (this.dt) {
        this.dt.sortField = 'engagementId';
        this.dt.sortOrder = -1;
        this.dt.reset();
      }
      if (
        this.paymentBatchEngagement === null ||
        this.paymentBatchEngagement.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        this.totalRecords = this.paymentBatchEngagement.length;
        if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    }
  }

  selectRow(e, l) {
    const patchBatchEngagement = this.paymentBatchEngagement.find(
      item =>
        item.engagementId === l.engagementId &&
        item.paymentLineItemId == l.paymentlineItemID
    );

    if (patchBatchEngagement) {
      if (e === true) {
        patchBatchEngagement.editCheckBox = true;
      } else {
        patchBatchEngagement.editCheckBox = false;
      }
    }
  }

  getPaymentBatchStatus() {
    this.csiPaymentService
      .getMilestone2PaymentBatchStatus()
      .subscribe(engList => {
        this.paymentBatchStatus = engList;
      });
  }

  onSubmit() {
    this.loading = true;
    this.updatePaymentBatch = {};

    const batchDetails: Milestone2PaymentScheduleBatch = {
      userId: this.settings.AliasName || '',
      paymentBatchScheduleDate:
        this.convertToDateTimeOffset(
          this.editPaymentBatchForm.controls['paymentBatchScheduleDate'].value
        ) || new Date(),
      anticipatedPaymentDate:
        this.convertToDateTimeOffset(
          this.editPaymentBatchForm.controls['anticipatedPaymentDate'].value
        ) || new Date(),
      actualPaymentCentralDate: this.editPaymentBatchForm.controls['actualPaymentCentralDate'].value
      ? this.convertToDateTimeOffset(   this.editPaymentBatchForm.controls['actualPaymentCentralDate'].value ) || null
        : null,
      paymentBatchStatusId:
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value.id,
      paymentBatchName:
        this.editPaymentBatchForm.controls['paymentBatchName'].value,
      paymentCentralRequestID:
        this.editPaymentBatchForm.controls['paymentCentralRequestID'].value
    } as Milestone2PaymentScheduleBatch;

    if (
      batchDetails.paymentBatchStatusId ===
      Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.selectedEngagements = [];
    }
    this.updatePaymentBatch.activities = [];
    if (
      this.selectedEngagements.length !== 0 ||
      this.selectedEngagements.length !== undefined ||
      batchDetails.paymentBatchStatusId ===
      Milestone2PaymentBatchStatus.Cancelled
    ) {
      for (const item of this.selectedEngagements) {
        this.updatePaymentBatch.activities.push({
          engagementId: item.engagementId?.toString(),
          engagementName: item.engagementName,
          engagementSubType: item.engagementSubType,
          tier: item.tier,
          fundingAmount: item.fundingAmount,
          partnerId: item.partnerId,
          vendorID: item.vendorID,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          actualizedAmount: item.actualizedAmount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoicePaidDate: item.msInvoicePaidDate,
          paymentCentralTransactionID: item.paymentCentralTransactionID,
          engagementSubID: item.engagementSubID,
          paymentLineItemId: item.paymentLineItemId
        });
        const mn = this.paymentBatchEngagement.find(
          it => it.engagementId === item.engagementId
        );
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.engagementId);
        }
      }
    }
    if (
      this.selectedEngagements.length === 0 &&
      batchDetails.paymentBatchStatusId !==
      Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Activity from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }
    batchDetails.addids = this.selectedEngagements
      .filter(e => !this.isEngagementInAssociated(Number(e.engagementId)))
      .map(e => e.engagementId)
      .toString();
    batchDetails.editids = this.selectedEngagements
      .filter(e => e.edited)
      .map(e => e.engagementId)
      .toString();
    batchDetails.deleteids = this.copyAssociatedEngagements
      .filter(
        e =>
          !this.selectedEngagements.some(
            e2 => e2.engagementId === e.engagementId
          )
      )
      .map(e => e.engagementId)
      .toString();
    this.updatePaymentBatch.paymentScheduleBatch = batchDetails;
    this.csiPaymentService
      .updateMilestone2PaymentBatch(this.updatePaymentBatch)
      .subscribe(
        messageResponse => {
          this.loading = false;
          this.apires = messageResponse;
          this.selectedEngagements = [];
          this.setMessage('Payment Batch Updated Successfully', 'success');
          this.editPaymentBatchForm.reset();
          this.showForm = false;
          this.csiPaymentService
            .ProcessCsiPaymentCap()
            .toPromise()
            .then(() => {
              if (
                batchDetails.paymentBatchStatusId ===
                Milestone2PaymentBatchStatus.InProgress
              ) {
                this.csiPaymentService
                  .sendCsiCapLogicNotification(
                    this.paymentBatchEngagement
                      .filter(e => e.associated === 1)
                      .map(x => Number(x.engagementId))
                  )
                  .toPromise()
                  .then(result => {
                    if (result == false)
                      this.setMessage(
                        'Failed to send payment notification email',
                        'warn'
                      );
                  });
              }
              this.showForm = false;
            })
            .finally(() => {
              this.router.navigate(['events-payment-schedule'], {
                queryParams: {
                  tab: SpecialInvestmentPaymentScheduleTab.Milestone2
                },
                state: { programTypeGuid: this.program }
              });
            });
        },
        error => {
          this.loading = false;
          let errors: string[] = [];
          const paymentRequestIDWarningMessage =
            'Payment Central RequestID is already exists.';
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.setMessage(msg, 'warn', true);
            }
          } else if (error.error === paymentRequestIDWarningMessage) {
            this.setMessage(paymentRequestIDWarningMessage, 'warn');
          } else {
            this.setMessage(
              'Sorry an Error Occurred while Creating Payment Batch',
              'warn'
            );
          }
        }
      );
  }

  onRowEditInit(eng: CsiPaymentScheduleActivitiesM2) {
    this.clonedEngs[eng.engagementId || -1] = { ...eng };
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = true;
      this.firstEditInitEng = Object.create(eng);
    }
    this.editRowsCtr++;
    this.disableSubmit = true;
  }

  onRowEditSave(eng: CsiPaymentScheduleActivitiesM2) {
    if (eng.amount !== null) {
      delete this.clonedEngs[eng.engagementId || -1];
      eng.partnerId = this.firstEditInitEng.partnerId;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionID =
        this.firstEditInitEng.paymentCentralTransactionID;
      eng.edited = true;
      eng.tier = this.firstEditInitEng.tier;
      eng.fundingAmount = this.firstEditInitEng.fundingAmount;
      eng.vendorID = this.firstEditInitEng.vendorID;
      this.editRowsCtr--;
    }
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  onRowEditCancel(eng: CsiPaymentScheduleActivitiesM2, index: number) {
    this.paymentBatchEngagement[index] =
      this.clonedEngs[eng.engagementId || -1];
    delete this.clonedEngs[eng.engagementId || -1];
    const idx = this.selectedEngagements.findIndex(
      e => e.engagementId === eng.engagementId
    );
    this.selectedEngagements.splice(idx, 1);
    this.onAddNewActivity(this.isShowOnlyAssoctd);
    this.paymentBatchEngagement[index].editCheckBox = false;
    this.editing = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  get ProgramType() {
    return ProgramTypes;
  }

  cancelSearchNav() {
    this.router.navigate(['events-payment-schedule'], {
      queryParams: { tab: SpecialInvestmentPaymentScheduleTab.Milestone2 },
      state: { programTypeGuid: this.program }
    });
  }

  convertToDateTimeOffset(dateStr: any): Date | null {
    let date = new Date(dateStr);
    if (typeof dateStr === 'string') {
      const [month, day, year] = dateStr.split('/').map(Number);
      if (!month || !day || !year) {
        return null;
      }
      date = new Date(year, month - 1, day);
    }
    return date;
  }

  getDateText(date: any): string {
    if (typeof date === 'string' && !date.startsWith('0001-01-01')) {
      date = new Date(date);
    }
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return 'Missing';
    }
    if (date.toISOString().startsWith('0001-01-01')) {
      return 'Missing';
    }
    return date.toDateString();
  }

  onAddNewActivity(val) {
    this.isShowOnlyAssoctd = val;
    if (this.isShowOnlyAssoctd) {
      if (this.dt) {
        this.dt.filter(1, 'associated', 'equals');
      }
      this.totalRecords = this.paymentBatchEngagement.length;
      if (this.totalRecords === 0) {
        this.currentPageInfo = 'No Record Found';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords > this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords <= this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    } else {
      if (this.dt) {
        this.dt.reset();
      }

      this.totalRecords = this.paymentBatchEngagement.length;
      if (this.totalRecords === 0) {
        this.currentPageInfo = 'No Record Found';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords > this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords <= this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }
  convertToNumberValue(val: any): number {
    return Number(val);
  }
}
